/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy, Self, Optional, ChangeDetectorRef, OnInit } from '@angular/core';
import { UntypedFormControl, NgControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { TicketEditBaseComponent } from '../ticket-edit-base/ticket-edit-base.component';
import { MultiWrapperComponent } from '../multi-wrapper/multi-wrapper.component';
import ticketValidator from '@touchplan/config/lib/ticket-validators.json';
import { validatorHelper } from 'src/app/app-data/validators/validator-helpers';

@Component({
	selector: 'ticket-duration',
	templateUrl: './ticket-duration.component.html',
	styleUrls: ['./ticket-duration.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketDurationComponent extends TicketEditBaseComponent implements OnInit {
	public minValue = Math.floor(ticketValidator['liveDurationDays'].min);
	public maxValue = Math.ceil(ticketValidator['liveDurationDays'].max);

	public internalField: UntypedFormControl = new UntypedFormControl(
		null,
		validatorHelper('liveDurationDays')
	);

	constructor(
		@Self() @Optional() public control: NgControl,
		@Optional() public multiWrapper: MultiWrapperComponent,
		@Optional() protected cd: ChangeDetectorRef
	) {
		super(control, multiWrapper, cd);
	}

	public ngOnInit() {
		super.ngOnInit();

		this.internalField.valueChanges.pipe(takeUntil(this.shutdownSubject)).subscribe((val: number) => {
			this.onChange(val);
		});
	}

	public writeValue(obj: any) {
		// TP-4100
		// When the user (say) edits "4.5" to become "4.", the cursor starts after the 5,
		// the user hits DELETE, and the cursor is then after the period.
		// The "this.onChange" call above reports the value change from 4.5 to 4.
		//
		// There's a subscription that responds to that and it ends up setting the value of
		// this component to 4; see "TicketEditService.setDurationFromForm".
		//
		// But at that time, the (numeric) value of this component is
		// ALREADY the number 4.  If we did NOT have the following "if" check, then the
		// "super.writeValue" call would re-store 4 into the component's <input> and that
		// can have the undesired side-effect of moving the cursor from after the '.' to
		// its initial location at the beginning of the text field.
		// It will also remove the '.'.
		//
		// TP-4100 complains about these things.
		//
		// That's why we have this "if" check to prevent:
		//    - unnecessary movement of the cursor, and
		//    - incorrect removal of characters the user has typed
		//
		if (obj !== this.internalField.value) {
			super.writeValue(obj);
		}
	}
}
